import { Button } from '@/components/shadcn/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu';
import { cn } from '@/lib/utils';
import { DropdownMenuProps } from '@radix-ui/react-dropdown-menu';
import { TriangleUpIcon, TriangleDownIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { useState } from 'react';

export interface UserSettingsDropdownProps extends DropdownMenuProps {
  value: string;
}

const UserSettingsDropdown = ({
  children,
  value,
  ...props
}: UserSettingsDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen} {...props}>
      <DropdownMenuTrigger asChild>
        <Button
          variant='ghost'
          className={cn(
            'w-full max-w-full justify-start border border-gray-settings-button px-2 text-neutral-900 hover:bg-gray-settings-button',
            !value.toLowerCase().includes('select') &&
              'bg-gray-settings-button/80 hover:bg-gray-settings-button'
          )}
        >
          <div className='flex w-full items-center justify-between space-x-1 truncate'>
            <p className='truncate'>{value}</p>
            {isOpen ? <TriangleUpIcon /> : <TriangleDownIcon />}
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='max-h-[--radix-dropdown-menu-content-available-height] w-[--radix-dropdown-menu-trigger-width] p-0'>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
UserSettingsDropdown.displayName = DropdownMenu.displayName;

export { UserSettingsDropdown };
